import * as React from 'react';
import type { SVGProps } from 'react';
const Flag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.14 46.88C38.8338 48.0122 37.7876 49.4134 37.073 50.9874C36.3585 52.5615 35.9925 54.2714 36 56V224C36 227.183 37.2643 230.235 39.5147 232.485C41.7651 234.736 44.8174 236 48 236C51.1826 236 54.2348 234.736 56.4853 232.485C58.7357 230.235 60 227.183 60 224V181.72C82.84 164.6 102.1 172.6 130.68 186.72C146.91 194.72 165.42 203.92 185.48 203.92C200.2 203.92 215.76 198.98 231.86 185.04C233.156 183.917 234.196 182.528 234.91 180.969C235.624 179.41 235.996 177.715 236 176V56C236 53.6991 235.339 51.4467 234.096 49.5109C232.852 47.5752 231.078 46.0378 228.985 45.082C226.892 44.1262 224.569 43.7922 222.291 44.1198C220.014 44.4475 217.879 45.4229 216.14 46.93C191.43 68.34 171.61 60.24 141.32 45.25C113.19 31.27 78.17 13.94 40.14 46.88ZM212 170.26C189.16 187.39 169.9 179.37 141.32 165.26C118.16 153.76 90.33 140 60 153.87V61.69C82.84 44.57 102.1 52.57 130.68 66.69C146.91 74.69 165.42 83.89 185.48 83.89C194.637 83.9037 203.687 81.921 212 78.08V170.26Z"
      fill="currentColor"
    />
  </svg>
);
export default Flag;
